import { useEffect, useState } from 'react';
import { Loader2, ShieldAlert } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { saveTemporaryAuthSession } from '../utils/authSession';

type ImpersonationWindowPayload = {
  type: 'IMPERSONATION_SESSION';
  token: string;
  user: unknown;
};

export default function ImpersonationPage() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let attempts = 0;

    const timer = window.setInterval(() => {
      attempts += 1;

      try {
        if (!window.name) {
          if (attempts >= 100) {
            setError('未收到代登录会话，请关闭当前页面后重试。');
            window.clearInterval(timer);
          }
          return;
        }

        const payload = JSON.parse(window.name) as Partial<ImpersonationWindowPayload>;
        if (payload.type !== 'IMPERSONATION_SESSION' || !payload.token || !payload.user) {
          throw new Error('invalid payload');
        }

        saveTemporaryAuthSession(payload.user, payload.token);
        window.name = '';
        window.clearInterval(timer);
        navigate('/', { replace: true });
      } catch {
        if (attempts >= 100) {
          setError('代登录会话初始化失败，请返回管理后台重新发起。');
          window.clearInterval(timer);
        }
      }
    }, 100);

    return () => window.clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-light-bg flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-3xl border border-light-border bg-white p-8 text-center shadow-xl">
        {error ? (
          <>
            <ShieldAlert className="mx-auto mb-4 h-12 w-12 text-amber-500" />
            <h1 className="mb-2 text-xl font-semibold text-light-text">代登录初始化失败</h1>
            <p className="text-sm text-light-muted">{error}</p>
          </>
        ) : (
          <>
            <Loader2 className="mx-auto mb-4 h-12 w-12 animate-spin text-accent-blue" />
            <h1 className="mb-2 text-xl font-semibold text-light-text">正在建立代登录会话</h1>
            <p className="text-sm text-light-muted">页面准备完成后会自动跳转到首页。</p>
          </>
        )}
      </div>
    </div>
  );
}
